module.exports = __webpack_public_path__ + "static/media/blocks.5397d080.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flexhouse/blocks.jpg
// module id = 93
// module chunks = 0